function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8394 10.1489C21.9283 10.1489 22.0004 10.221 22.0004 10.3099V12C22.0004 12.6326 21.9416 13.2511 21.8289 13.8511C20.9571 18.5116 16.8513 22.0337 11.9298 21.9997C6.40762 21.9617 1.98816 17.4998 2.00039 11.9775C2.01254 6.46508 6.48512 2 12.0004 2C14.7024 2 17.1541 3.07195 18.954 4.8132C19.019 4.87605 19.0207 4.97965 18.9568 5.04356L16.5657 7.43461C16.5041 7.49617 16.4047 7.49777 16.3416 7.43773C15.2119 6.36238 13.6834 5.70219 12.0004 5.70219C8.52492 5.70219 5.72629 8.48094 5.7027 11.9563C5.67899 15.4545 8.50774 18.2978 12.0004 18.2978C14.8341 18.2978 17.2309 16.4257 18.0213 13.8511H12.1613C12.0724 13.8511 12.0004 13.779 12.0004 13.6901V10.3098C12.0004 10.2209 12.0724 10.1489 12.1613 10.1489H21.8394V10.1489Z",
  fill: "#2196F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.27971 9.36258L3.24268 7.1682C4.9465 4.08652 8.22979 2 12 2C14.7021 2 17.1537 3.07195 18.9537 4.8132C19.0187 4.87605 19.0204 4.97965 18.9564 5.04355L16.5654 7.43461C16.5039 7.49606 16.4045 7.49797 16.3415 7.43805C15.2118 6.3625 13.6832 5.70223 12 5.70223C9.46361 5.70223 7.27729 7.2016 6.27971 9.36258Z",
  fill: "#F44336"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3357 18.796C17.5095 20.7666 14.8986 22 12 22C8.08497 22 4.69544 19.7501 3.05396 16.4724L6.15454 14.3477C7.08497 16.6628 9.35177 18.2978 12 18.2978C13.662 18.2978 15.1735 17.6539 16.2986 16.602L19.3357 18.796Z",
  fill: "#4CAF50"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.70223 12C5.70223 12.8298 5.86277 13.6222 6.15453 14.3477L3.05391 16.4724C2.37949 15.1268 2 13.6077 2 12C2 10.2475 2.4507 8.6004 3.24266 7.16821L6.27969 9.36259C5.90906 10.1646 5.70223 11.0584 5.70223 12Z",
  fill: "#FFC107"
});

var SvgGoogle = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google.5499ca87.svg";
export { ForwardRef as ReactComponent };